/* document.addEventListener('DOMContentLoaded', function () {

  // Show answer for active item on load
  document.querySelectorAll('.faq-item.active .faq-answer').forEach(function (el) {
    el.style.display = 'block';
  });

  document.querySelectorAll('.faq-question').forEach(function (question) {
    question.addEventListener('click', function () {

      let parent = this.closest('.faq-item');
      let answer = parent.querySelector('.faq-answer');

      if (parent.classList.contains('active')) {
        // Close current
        parent.classList.remove('active');
        answer.style.display = 'none';
      } else {
        // Close all
        document.querySelectorAll('.faq-item').forEach(function (item) {
          item.classList.remove('active');
          let ans = item.querySelector('.faq-answer');
          if (ans) ans.style.display = 'none';
        });

        // Open clicked
        parent.classList.add('active');
        answer.style.display = 'block';
      }

    });
  });

}); */
$(document).ready(function () {

  // 👉 Open first accordion by default
  let firstItem = $('.faq-item').first();
  firstItem.addClass('active');
  firstItem.find('.faq-answer').show(); // no animation on load

  // 👉 Click functionality
  $('.faq-question').on('click', function () {
    let parent = $(this).closest('.faq-item');
    let answer = parent.find('.faq-answer');

    if (parent.hasClass('active')) {
      parent.removeClass('active');
      answer.stop(true, true).slideUp(400);
    } else {
      $('.faq-item').removeClass('active');
      $('.faq-answer').stop(true, true).slideUp(400);

      parent.addClass('active');
      answer.stop(true, true).slideDown(400);
    }
  });

});